import React from 'react';
import { Grid } from '@material-ui/core';
import Modal from '../../../../components/Modal/modal';
import DiffRetainer from '../../../../pages/DiffRetainer/DiffRetainer';
import { useHistory } from 'react-router-dom';

const ReSubmitRetainerFormModal = ({ open, handleClose, ...props }) => {
    const { caseId, caseImpressionId, retainerRequestId } = props;
    const history = useHistory();
    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    const resubmitProps = {
        caseId,
        caseImpressionId,
        retainerRequestId,
    };

    return (
        <Modal handleClose={onClose} open={open} title="Resubmit Retainer Form">
            <Grid>
                <DiffRetainer isReSubmit={true} resubmitProps={resubmitProps} history={history} />
            </Grid>
        </Modal>
    );
};

export default ReSubmitRetainerFormModal;
